<template>
  <Modal
    class="tw-translate-y-[-50%] assessment-modal tw-max-w-[680px]"
    :visible="showRef"
    @close="handleCloseModal"
  >
    <ModalHeader
      :class="`modal-header tw-capitalize ${titleClass}`"
      :title="props.value.title"
      @close="handleCloseModal"
    />
    <div
      class="tw-p-3 tw-border-b-[1px] tw-border-0 tw-border-solid tw-border-[#EFF0F1] md:tw-p-10"
    >
      <div
        class="tw-bg-[#387DFF] tw-inline-flex tw-px-[5px] tw-py-[3px] tw-rounded tw-mr-[10px]"
      >
        <span
          class="tw-text-white tw-text-[11px] tw-font-medium tw-leading-[130%]"
          >{{ props.value.category }}</span
        >
      </div>
      <div
        class="tw-bg-[#F2F8FF] tw-inline-flex tw-px-[5px] tw-py-[3px] tw-rounded"
      >
        <span
          class="tw-text-[#387DFF] tw-text-[11px] tw-font-medium tw-leading-[130%]"
          >{{ props.value.subCategory }}</span
        >
      </div>
      <div class="tw-mt-[12px]">
        <span
          class="tw-mr-[15px] tw-font-semibold tw-text-[20px] tw-text-[#211F58]"
          >{{ props.value.questionNumber }}</span
        >
        <span class="tw-font-normal tw-text-[20px] tw-text-[#211F58]">{{
          props.value.questionTitle
        }}</span>
      </div>
    </div>

    <!-- Override Assessment Question -->
    <div class="body-container">
      <SwitchTabs
        :tabs="tabs"
        :default-tab="value.compensatingOverrideScore ? 1 : 0"
        @update:tab="tabValue = $event"
      />
      <OverrideAssessmentQuestion :type="tabValue" :value="props.value" />
    </div>
  </Modal>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import Modal from "@/components/common/modal.vue";
import ModalHeader from "@/components/common/modalHeader.vue";
import {
  AssessmentAnswerType,
  IAssessmentQuestion,
} from "@/interfaces/assessments/IAssessmentQuestion";
import { PropType } from "vue";
import SwitchTabs from "../assessments/switchTabs.vue";
import OverrideAssessmentQuestion from "./overrideAssessmentQuestion.vue";
import { ISwitchTabs } from "@/interfaces/assessments/ISwitchTabs";

const props = defineProps({
  show: {
    type: Boolean,
    required: false,
  },
  titleClass: {
    type: String,
    default: "",
  },
  value: {
    type: Object as PropType<IAssessmentQuestion>,
    default: () => ({}),
    required: true,
  },
});
const tabValue = ref(
  props.value.compensatingOverrideScore
    ? AssessmentAnswerType.COMPENSATING
    : AssessmentAnswerType.COMPLIANCE,
);
const tabs: ISwitchTabs[] = [
  { title: "Compliance override", id: AssessmentAnswerType.COMPLIANCE },
  { title: "Compensating controls", id: AssessmentAnswerType.COMPENSATING },
];

let showRef = ref(props.show);
let notInfoVisible = ref(true);
watch(
  () => props.show,
  (value) => {
    showRef.value = value;
    if (value) notInfoVisible.value = true;
  },
);

const emit = defineEmits(["update:show"]);
const handleCloseModal = () => {
  showRef.value = false;
  emit("update:show", showRef.value);
};
</script>

<style lang="scss">
.assessment-modal {
  .button-verify.btn.btn-primary[disabled] {
    background-color: #dbdbdb;
    color: #b7b7b7;
    border-color: #dbdbdb;
  }

  .button-verify {
    line-height: 100%;
    background-color: #387dff;
    border-color: #387dff;
  }
}

@media (max-width: 768px) {
  .assessment-modal {
    .modal-assessment,
    .modal-header {
      padding-right: 10px;
      padding-left: 10px;
    }
  }
}
</style>
